import { createTriggerResource } from '@magicdoorinc/ui';
import { createMagicDoorContext } from '~/contexts/utils';
import { EmailRepository } from '~/repositories/emailRepository';
import type { EmailFilter } from '~/repositories/emailRepository';
import type { SendEmailJsonDto } from '~/swagger/portal/Api';

const repo = new EmailRepository();

export const [EmailsProvider, useEmails] = createMagicDoorContext('Emails', () => {
  const [email, getEmail] = createTriggerResource((emailId: string) => repo.getEmail(emailId));

  const getOwnerEmails = async (ownerId: string, filter?: EmailFilter) => {
    return await repo.getOwnerEmails(ownerId, filter);
  };

  const getTenantEmails = async (tenantId: string, filter?: EmailFilter) => {
    return await repo.getTenantEmails(tenantId, filter);
  };

  const getLeaseEmails = async (leaseId: string, filter?: EmailFilter) => {
    return await repo.getLeaseEmails(leaseId, filter);
  };

  const getVendorEmails = async (vendorId: string, filter?: EmailFilter) => {
    return await repo.getVendorEmails(vendorId, filter);
  };

  const sendVendorEmails = async (vendorId: string, payload: SendEmailJsonDto) => {
    return await repo.sendVendorEmailJson(vendorId, payload);
  };

  const sendOwnersEmails = async (ownerId: string, payload: SendEmailJsonDto) => {
    return await repo.sendOwnerEmailJson(ownerId, payload);
  };

  const sendLeasesEmails = async (leaseId: string, payload: SendEmailJsonDto) => {
    return await repo.sendLeaseEmailJson(leaseId, payload);
  };

  const sendTenantsEmails = async (tenantId: string, payload: SendEmailJsonDto) => {
    return await repo.sendTenantEmailJson(tenantId, payload);
  };

  return {
    email,
    getEmail,
    getOwnerEmails,
    getTenantEmails,
    getLeaseEmails,
    getVendorEmails,
    sendVendorEmails,
    sendOwnersEmails,
    sendLeasesEmails,
    sendTenantsEmails,
  };
});
